import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackEditIntegrationEvent =
  createAnalyticsTracker('editIntegration');
